import { Integration } from '../../../shared/interfaces/integration';
import { WizardStepTrackerStep } from '../../../wizard/interfaces/wizard-step';
import { CreatePipelineStepPaths } from '../create-pipeline-state-machine/interfaces/create-pipeline-step-paths';
import { shouldResumePipelineCreate } from '../../utils/pipelineUtil';

export function resolveCreatePipelineSteps(
  integration: Integration,
  fastTravelToSourceSettings = false
): {
  completed: boolean;
  steps: WizardStepTrackerStep[];
  nextStep: string;
} {
  const status = integration.status.value;

  if (!shouldResumePipelineCreate(status)) {
    return {
      steps: [],
      nextStep: '',
      completed: true
    };
  }

  return {
    completed: false,
    steps: [
      {
        path: CreatePipelineStepPaths.SELECT_SOURCE_TYPE,
        complete: fastTravelToSourceSettings,
        data: {}
      },
      ...(fastTravelToSourceSettings
        ? [
            {
              path: CreatePipelineStepPaths.SOURCE_CONNECTION_SETTINGS,
              complete: false,
              data: {}
            }
          ]
        : [])
    ],
    nextStep: fastTravelToSourceSettings
      ? CreatePipelineStepPaths.SOURCE_CONNECTION_SETTINGS
      : CreatePipelineStepPaths.SELECT_SOURCE_TYPE
  };
}
